import { ReactNode, useEffect, useRef, useState } from 'react';

import Text from '@cartwhl/ui/base/Text';
import ChevronDownIcon from '@cartwhl/ui/icons/ChevronDownIcon';
import Button from '@cartwhl/ui/input/Button';

export const ProjectList = ({
  children,
  title,
  amount,
  viewMode = 'grid',
}: {
  children: ReactNode;
  title: string;
  amount?: number;
  viewMode?: 'grid' | 'list';
}) => {
  // Initialize collapsed state: closed if bookmarks and empty, otherwise open
  const [collapsed, setCollapsed] = useState(() => {
    if (title === 'Bookmarks') {
      return (amount ?? 0) === 0;
    }
    return false;
  });
  const prevAmountRef = useRef(amount);

  // For bookmarks section: open automatically when items are added (from 0 to >0)
  useEffect(() => {
    if (title === 'Bookmarks' && amount !== undefined) {
      const prevAmount = prevAmountRef.current;
      if (prevAmount === 0 && amount > 0) {
        setCollapsed(false);
      }
      prevAmountRef.current = amount;
    }
  }, [amount, title]);
  return (
    <div className="flex flex-col gap-5 py-8">
      <div className="flex items-center justify-between px-2">
        <Text as="h2" variant="studio/body/md" md:variant="studio/subtitle">
          {title}{' '}
          {amount !== undefined && (
            <span className="text-gray-45 dark:text-gray-60">({amount})</span>
          )}
        </Text>
        <Button
          variant="tertiary"
          size="sm"
          icon={<ChevronDownIcon className={collapsed ? '-rotate-90' : ''} />}
          onClick={() => setCollapsed(!collapsed)}
        />
      </div>
      {!collapsed && (
        <div
          className={
            viewMode === 'list'
              ? 'flex flex-col gap-2'
              : 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:px-0'
          }
        >
          {children}
        </div>
      )}
    </div>
  );
};
